import { ApiResourceBaseClass as r } from "./baseApiCalls.js";
const o = "business", e = {
  gmb: "google-locations",
  facebook: "facebook-pages"
};
class u extends r {
  /**
   * Get Facebook auto-match suggestions.
   *
   * HTTP Verb: GET
   * Endpoint URL: /business/facebook-suggested
   */
  getFacebookAutoMatchSuggestions = async () => {
    const { data: t } = await this.get(
      `${o}/facebook-suggested`
    );
    return t;
  };
  /**
   * Get Google My Business auto-match suggestions.
   *
   * HTTP Verb: GET
   * Endpoint URL: /business/google-suggested
   */
  getGmbAutoMatchSuggestions = async () => {
    const { data: t } = await this.get(
      `${o}/google-suggested`
    );
    return t;
  };
  /**
   * Connect a business to a Google or Facebook location.
   *
   * HTTP Verb: POST
   * Endpoint URL: /business/:businessId/connect/:partner/:locationId
   */
  connectBusinessToLocation = async (t, s, n, a) => {
    const { data: c } = await this.post(
      `${o}/${t}/connect/${e[n]}/${s}`,
      a
    );
    return c;
  };
  /**
   * Disconnect a business from a Google or Facebook location.
   *
   * HTTP Verb: POST
   * Endpoint URL: /business/:businessId/disconnect/:partner
   */
  disconnectBusinessFromLocation = async (t, s) => {
    const { data: n } = await this.post(
      `${o}/${t}/disconnect/${e[s]}`
    );
    return n;
  };
  /**
   * Connect a business to TripAdvisor using a FormData payload.
   *
   * HTTP Verb: POST
   * Endpoint URL: /business/connect/tripadvisor
   */
  tripAdvisorConnectionCall = async (t) => {
    const { data: s } = await this.post(
      `${o}/connect/tripadvisor`,
      t,
      { "Content-Type": "multipart/form-data" }
    );
    return s;
  };
  /**
   * Count the number of Google connection errors for businesses.
   *
   * HTTP Verb: GET
   * Endpoint URL: /business/partner-connections-errors/google/count
   */
  googleConnectionsErrorsCount = async () => {
    const { data: t } = await this.get(
      `${o}/partner-connections-errors/google/count`
    );
    return t;
  };
}
export {
  u as PublisherConnection
};
